import { useEffect, useState } from "react"

import { PlusOutlined } from "@ant-design/icons"
import { Flex, Tabs, Typography } from "antd"
import cls from "classname"
import { useTranslation } from "react-i18next"
import { useLocation, useNavigate } from "react-router-dom"

import ButtonComponent from "../../../../Components/Button"
import { buildPublicApiDocsUrl } from "../../../../Utils/utils"
import * as services from "../services"
import EndpointsTable from "./EndpointsTable"
import EventsTable from "./EventsTable"

import "./webhooks.less"

const { Title, Text, Link } = Typography

// TODO: Remove temporary events/details fallbacks after webhooks backend is available.
const WebhooksPage = () => {
  const { t } = useTranslation()

  const [activeKey, setActiveKey] = useState("endpoints")
  const [modalType, setModalType] = useState(null)
  const [webhooksSettings, setWebhooksSettings] = useState(null)
  const location = useLocation()
  const navigate = useNavigate()

  const eventTypeOptions = (webhooksSettings?.event_types || []).filter((item) => item?.value)
  const docsUrl = buildPublicApiDocsUrl(webhooksSettings?.docs_url)
  const docsLabel = webhooksSettings?.docs_label || "See API documentation"
  const description =
    webhooksSettings?.description || "API keys allow you to accesss your own data via the API."

  const openAddEndpointModal = () => {
    setModalType({ type: "add_endpoint" })
  }

  useEffect(() => {
    const fromEventDetails = location?.state?.fromEventDetails

    // if (fromEndpointDetails) {
    //   setActiveKey('endpoints')
    //   navigate(location.pathname, { replace: true })
    // }

    if (fromEventDetails) {
      setActiveKey("events")
      navigate(location.pathname, { replace: true })
    }
  }, [])

  useEffect(() => {
    const loadSettings = async () => {
      const response = await services.getPublicApiSettings()
      if (response?.ok && response?.data?.webhooks) {
        setWebhooksSettings(response.data.webhooks)
      }
    }

    loadSettings()
  }, [])

  const items = [
    {
      key: "endpoints",
      label: "Endpoints",
      children: (
        <EndpointsTable
          modalType={modalType}
          setModalType={setModalType}
          eventTypeOptions={eventTypeOptions}
          openAddEndpointModal={openAddEndpointModal}
        />
      )
    },
    {
      key: "events",
      label: "Events",
      children: (
        <div style={{ marginTop: 21 }}>
          <EventsTable eventTypeOptions={eventTypeOptions} />
        </div>
      )
    }
  ]

  const handleChangeTab = (key) => {
    setActiveKey(key)
    // navigate(`/settings/webhooks/${key}`)
  }

  // useEffect(() => {
  //   if (key !== activeKey) {
  //     setActiveKey(key)
  //   }
  // }, []);

  return (
    <div className="webhooks-page">
      <div className="header" style={{ marginBottom: 23 }}>
        <Title level={4}>Webhooks</Title>
        <Text type="secondary" style={{ fontWeight: 500 }}>
          {description}
          <a href={docsUrl} target="_blank" rel="noreferrer">
            <Link> {docsLabel}</Link>
          </a>
        </Text>
      </div>
      <Flex gap={12}>
        <Tabs
          className={cls("webhooks-tabs", { [activeKey]: true })}
          activeKey={activeKey}
          items={items}
          style={{ width: "100%" }}
          tabBarExtraContent={
            activeKey === "endpoints"
              ? {
                  right: (
                    <ButtonComponent
                      icon={<PlusOutlined style={{ fontSize: 14 }} />}
                      className="flex"
                      style={{ width: 128, marginTop: 10 }}
                      onClick={openAddEndpointModal}
                    >
                      {t("Add endpoint")}
                    </ButtonComponent>
                  )
                }
              : null
          }
          onChange={handleChangeTab}
        />
      </Flex>
    </div>
  )
}

export default WebhooksPage
